export default require.context('../reducers', true, /^\.\/.*\.js$/).keys();
